import type { SvgIconComponent } from '@mui/icons-material';
import { Tune as TuneIcon } from '@mui/icons-material';
import { FILTER } from 'constants/actions';
import { t } from 'utils/i18n';
import useFiltersCount from './useFiltersCount';

export interface FiltersActionBadge {
  badgeContent: number;
  color: 'primary';
}

export interface FiltersAction {
  id: string;
  title: string;
  icon: SvgIconComponent;
  show: 'always';
  badge: FiltersActionBadge | null;
}

const useFiltersAction = (
  filters: Record<string, unknown>,
  excludedKeys: string[] = [],
): FiltersAction => {
  const appliedFiltersCount = useFiltersCount(filters, excludedKeys);
  return {
    id: FILTER,
    title: t(FILTER),
    icon: TuneIcon,
    show: 'always',
    badge:
      appliedFiltersCount === 0
        ? null
        : { badgeContent: appliedFiltersCount, color: 'primary' },
  };
};

export default useFiltersAction;
